import type { QueryClient } from "@tanstack/react-query";
import {
  getAllTenantsQueryKey,
  getTenantQueryKey,
} from "@harmonyso/tenants-sdk";
import { cellRequestOptions } from "./cells";

/**
 * Invalidates a cell's tenant list and, given a tenant id, that tenant's
 * detail. Each key carries the cell's base URL, so this must be used instead
 * of the SDK's bare keys, which only ever match the primary cell.
 */
export function invalidateCellTenantQueries(
  queryClient: QueryClient,
  deploymentCell: string | null | undefined,
  tenantId?: string,
): void {
  const cellOptions = cellRequestOptions(deploymentCell);
  void queryClient.invalidateQueries({
    queryKey: getAllTenantsQueryKey(cellOptions),
  });
  if (tenantId) {
    void queryClient.invalidateQueries({
      queryKey: getTenantQueryKey({
        ...cellOptions,
        path: { tenant_id: tenantId },
      }),
    });
  }
}
